import React from 'react'
import {cepMask} from '../../../utils/cepMask'
import {phoneMask} from '../../../utils/phoneMask'
import {IPersonResponse} from '../../../coreGlobal/models/person'
import {formatDate} from '../../../utils/dayJs/format'

interface IListPersonalData {
  person: IPersonResponse | undefined
}

const ListPersonalData = ({person}: IListPersonalData) => (
  <>
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Informações Pessoa Fisica</h3>
        </div>
      </div>

      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            <tbody>
              <tr>
                <td>
                  <b>RG:</b> {person?.physicalPerson?.rg}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <b>CPF:</b> {person?.physicalPerson?.document}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Idade:</b> {person?.physicalPerson?.age}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Data de Nascimento:</b>{' '}
                  {person?.physicalPerson?.birthDate
                    ? formatDate(person.physicalPerson.birthDate)
                    : ''}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Gênero:</b> {person?.physicalPerson?.gender == 'F' ? 'Feminino' : 'Masculino'}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Profissão:</b> {person?.physicalPerson?.job}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Nacionalidade:</b> {person?.physicalPerson?.nationality?.name}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Tempo de agendamento reduzido?</b> {person?.reduceTime ? 'Sim' : 'Não'}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Avatar neutro?</b> {person?.physicalPerson?.hideAvatar ? 'Sim' : 'Não'}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Como ficou sabendo da Dr. Laser?</b>{' '}
                  {person?.howMetId == 8
                    ? `${person.howMetName} - ${person?.howMetObservation}`
                    : person?.howMetName}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Informações de Contato</h3>
        </div>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table
            id='teste'
            className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'
          >
            <tbody>
              <tr>
                <td>
                  <b>E-mail:</b> {person?.email}
                </td>
              </tr>
            </tbody>
          </table>
          <table className='table table-row-dashed table-row-gray-300'>
            <thead>
              <tr>
                <th></th>
                <th>
                  <b>Tipo</b>
                </th>
                <th>
                  <b>Número</b>
                </th>
              </tr>
            </thead>
            <tbody>
              {person?.contacts.map((contact, index) => (
                <tr key={`listPersonalDataContracts${index}`}>
                  <td>
                    <b>Telefone {index + 1} : </b>
                  </td>
                  <td>{contact?.typeName}</td>
                  <td>{phoneMask(contact?.phone)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Informações de Endereço</h3>
        </div>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            <tbody>
              {person?.addresses?.map((address, index) => (
                <React.Fragment key={`listPersonalDataAddress${index}`}>
                  <tr>
                    <td>
                      <b>CEP:</b> {cepMask(address?.zipCode)}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Rua:</b> {address?.street}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Número:</b> {address?.number}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Complemento:</b> {address?.complement}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Bairro: </b>
                      {address?.neighborhood}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Cidade:</b> {address?.city?.name} - {address?.city?.state?.uf}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Estado:</b> {address?.city?.state?.name}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </>
)

export {ListPersonalData}
